module.exports = __webpack_public_path__ + "img/chess_checkersred.703bd85a.png";